/* eslint-disable no-plusplus */
import { Button, Input, Loader, ModalGeneric, SelectGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';

import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import useMultiplPositionAndLine from '../../../hooks/useMultiplePositionAndLine';
import './AddMultiplePLModal.scss';

const AddMultiplePLModal = ({
  positions,
  contractNumber,
  onCloseModal,
  onSubmitPL,
  showModal,
  isWorkReport
}) => {
  const {
    lines,
    loading,
    changeLineState,
    pLFieldArrayValues,
    changePLFieldArrayValues,
    duplicatePositionLine,
    handleAddPL,
    handleSuprPL,
    handleChangePositionValue,
    handleChangeLineValue,
    handleChangeAmountValue,
    isPOrLEmpty
  } = useMultiplPositionAndLine({ contractNumber, isMonthly: null });

  const onClose = () => {
    changePLFieldArrayValues([{}]);
    changeLineState([]);
    onCloseModal();
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => onClose()}
      primaryAction={() => {
        onSubmitPL(pLFieldArrayValues);
        onClose();
      }}
      primaryActionDisabled={isPOrLEmpty || duplicatePositionLine()}
      primaryActionLabel="Agregar"
      secondaryAction={() => onClose()}
      secondaryActionLabel="Salir"
      show={showModal}
      size="xl"
      title="Agregar líneas al parte"
    >
      <>
        {loading && <Loader show text="CARGANDO ..." />}
        {pLFieldArrayValues.map((pLFieldArrayValue, index) => (
          <Row key={`${pLFieldArrayValue?.position?.id}-${pLFieldArrayValue?.line?.id}`}>
            <Col sm={isWorkReport ? 5 : 4}>
              {positions && (
                <SelectGeneric
                  defaultValueOneOption={false}
                  isDisabled={false}
                  label="Posición"
                  name={`position-${index}`}
                  onChange={(val) => handleChangePositionValue(val, index)}
                  optionMapper={{
                    value: 'id',
                    label: 'nombre'
                  }}
                  options={positions}
                  paddingIndicator={4}
                  placeholder="Seleccioná una posición"
                  value={pLFieldArrayValue.position}
                  withSelect="100%"
                />
              )}
            </Col>
            <Col sm={isWorkReport ? 5 : 4}>
              <SelectGeneric
                defaultValueOneOption={false}
                isDisabled={!pLFieldArrayValue.position}
                label="Línea"
                name={`line-${index}`}
                onChange={(val) => handleChangeLineValue(val, index)}
                optionMapper={{
                  value: 'id',
                  label: 'nombre'
                }}
                options={lines[index]}
                paddingIndicator={4}
                placeholder="Seleccioná una línea"
                value={pLFieldArrayValue.line}
                withSelect="100%"
              />
            </Col>
            {!isWorkReport && (
              <Col sm={2} style={{ display: 'flex' }}>
                <Input
                  className="template-name-input w-100"
                  disabled={!pLFieldArrayValue.line}
                  label="Cantidad"
                  onChange={(val) => handleChangeAmountValue(val, index)}
                  placeholder="--"
                  type="number"
                  value={pLFieldArrayValue.amount}
                />
              </Col>
            )}
            <Col sm={2} style={{ display: 'flex' }}>
              <div
                style={{
                  marginTop: '15px',
                  display: 'flex',
                  gap: '5px',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Button
                  colorIcon="danger"
                  disabled={pLFieldArrayValues.length === 1}
                  icon={AiOutlineMinusCircle}
                  onClick={() => handleSuprPL(index)}
                  sizeIcon="24px"
                  type="button"
                  variant="light-gray"
                  widthButton="40px"
                />
                <Button
                  colorIcon="primary"
                  disabled={pLFieldArrayValues.find((pLObj) => !pLObj.position || !pLObj.line)}
                  icon={AiOutlinePlusCircle}
                  onClick={() => handleAddPL()}
                  sizeIcon="24px"
                  type="button"
                  variant="light-gray"
                  widthButton="40px"
                />
              </div>
            </Col>
          </Row>
        ))}
        {duplicatePositionLine() && (
          <div>
            <ErrorMessage message="Posición y Línea repetida. Selecciona otra combinación." />
          </div>
        )}
      </>
    </ModalGeneric>
  );
};

AddMultiplePLModal.propTypes = {
  positions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcionSap: PropTypes.string,
      descripcionYClick: PropTypes.string,
      numeroPosicion: PropTypes.number
    })
  ).isRequired,
  contractNumber: PropTypes.number.isRequired,
  onSubmitPL: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  isWorkReport: PropTypes.bool
};

AddMultiplePLModal.defaultProps = {
  isWorkReport: false
};

export default AddMultiplePLModal;
